<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg936"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs940"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath950"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path948" /></clipPath><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath970"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path968" /></clipPath></defs><g
     id="g942"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g944"><g
         id="g946"
         clip-path="url(#clipPath950)"><g
           id="g952"
           transform="translate(482,191.2872)"><path
             d="M 0,0 V 101.286 H -452 V -181.287 H 0 V -80"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path954" /></g><g
           id="g956"
           transform="translate(346.6667,382.9971)"><path
             d="m 0,0 h 44.792 l 90.541,-90.424 h -452 L -226.302,0 H -159"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path958" /></g></g></g><g
       id="g960"
       transform="translate(154.1558,337.7854)"><path
         d="M 0,0 H 203.688"
         style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path962" /></g><g
       id="g964"><g
         id="g966"
         clip-path="url(#clipPath970)"><g
           id="g972"
           transform="translate(256.0001,229.2868)"><path
             d="m 0,0 v 0 c -43.078,0 -78,-34.922 -78,-78 v 0 c 0,-43.078 34.922,-78 78,-78 v 0 c 43.078,0 78,34.922 78,78 v 0 C 78,-34.922 43.078,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path974" /></g><g
           id="g976"
           transform="translate(224.9856,155.9011)"><path
             d="m 0,0 21.939,-21.939 40.09,40.09"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path978" /></g><g
           id="g980"
           transform="translate(280.6422,470.3578)"><path
             d="m 0,0 -101.695,-101.695 30.878,-30.877 H 19.81 L 107.831,-44.551 31.64,31.64 0,0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path982" /></g><g
           id="g984"
           transform="translate(482,151.2868)"><path
             d="M 0,0 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path986" /></g></g></g></g></svg>
</template>
